import { captureException } from '@sentry/nextjs';
import { QuotePayload } from 'models/life-insurance';

export const submitLifeQuoteRequest = (payload: QuotePayload) =>
  fetch(`${process.env.NEXT_PUBLIC_FEATHER_API_URL}/life/quote`, {
    method: 'POST',
    headers: {
      'Content-type': 'application/json',
    },
    body: JSON.stringify(payload),
  });

export const submitApplicationForm = async (formData: FormData) => {
  const response = await fetch('/api/applications', {
    method: 'POST',
    body: formData,
  });
  return response.json();
};

export async function getFeatureFlags() {
  let featureFlags: Record<string, boolean> = {};
  try {
    const response = await fetch(process.env.UNLEASH_API_URL || '', {
      credentials: 'include',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: process.env.UNLEASH_CLIENT_KEY || '',
      },
    });

    const data: {
      toggles: Array<{
        name: string;
        enabled: boolean;
        variant: { name: string; enabled: boolean };
      }>;
    } = await response.json();

    featureFlags = data?.toggles.reduce(
      (flags, { name, enabled }) => ({
        ...flags,
        [name]: enabled,
      }),
      {}
    );
  } catch (error) {
    captureException(error);
  }

  return featureFlags;
}
